import gql from 'graphql-tag';


export const addCatalogue = gql`

mutation demo($catalogueObj: catalogues_insert_input!) {
  insert_catalogues_one(object: $catalogueObj) {
    id
  }
}

`;



export const getCatalogue = gql`

subscription getCatalogue($id: uuid!){
  catalogues(order_by: {approved_at: desc },where: {dental_supplier_id:{_eq: $id},status: {_eq: "APPROVED"}}) {
    id
    title
    catalogue_status
    views
    status
    schedulerDay
    created_at
    catalogue_category{
      id
      name
    }
    j_catalogues_catalogue_tags{
      id
    }
  }
}

`;



export const getCatalogueByPk = gql`

query getCatalogueByPk($id: uuid!){
  catalogues_by_pk(id:$id){
  id
  title
  attachment
  thumbnail_image
  catalogue_status
  catalogue_category{
    id
    name
  }
  j_catalogues_catalogue_tags{
    id
    catalogue_id
    catalogue_tag_id
  }


}
}

`;




export const getCatalogueCategories = gql`

query getCatalogueCategories {
  catalogue_categories(where: {status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;

export const getCatalogueSubCategories = gql`

query getCatalogueSubCategories {
  catalogue_sub_categories(where: {status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;
export const getCatalogueType = gql`

query getCatalogueSubCategories {
  catalogue_categories(where: {status: {_eq: "ACTIVE"}}){
    id
    name
  }
}

`;


export const getAdminCatalogues = gql`

query getAdminCatalogues {
  catalogues(order_by: {approved_at: desc },where: {status: {_eq: "APPROVED"}}){

    id
    title
    catalogue_status
    schedulerDay
    views
    dental_supplier{
      name
    }
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;


export const getAdminPendingCatalogues = gql`

subscription getAdminPendingCatalogues {
  catalogues(order_by: {pending_at: desc },where: {status: {_eq: "PENDING_APPROVAL"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    schedulerDay
    dental_supplier{
      name
    }
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;







export const getUserPendingCatalogues = gql`

subscription getUserPendingCatalogues($id:uuid!) {
  catalogues(order_by: {pending_at: desc },where: {dental_supplier_id:{_eq: $id},status: {_eq: "PENDING_APPROVAL"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    views
    status
    schedulerDay
    catalogue_category{
      id
      name
    }
   
  }
}

`;

export const getUserApprovedCatalogues = gql`

subscription getUserApprovedCatalogues($id:uuid!) {
  catalogues(where: {dental_supplier_id:{_eq: $id},status: {_in: ["APPROVED", "SCHEDULED"]}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    views
    status
    schedulerDay
    catalogue_category{
      id
      name
    }
   
  }
}

`;



export const getUserDraftCatalogues = gql`

subscription getUserDraftCatalogues($id:uuid!) {
  catalogues(where: {dental_supplier_id:{_eq: $id},status: {_eq: "DRAFT"}}){

    id
    title
    created_at
    thumbnail_image
    dental_supplier_id
    schedulerDay
    catalogue_status
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;





export const getUserRejectedCatalogues = gql`

subscription getUserRejectedCatalogues($id:uuid!) {
  catalogues(where: {dental_supplier_id:{_eq: $id},status: {_eq: "REJECTED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    schedulerDay
    rejected_at
    reject_reason
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;



export const getUserExpiredCatalogues = gql`

subscription getUserExpiredCatalogues($id:uuid!) {
  catalogues(where: {dental_supplier_id:{_eq: $id},status: {_eq: "EXPIRED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    views
    status
    schedulerDay
    catalogue_category{
      id
      name
    }
   
  }
}

`;

export const getUserScheduledCatalogues = gql`

subscription getUserScheduledCatalogues($id:uuid!) {
  catalogues(where: {dental_supplier_id:{_eq: $id},status: {_eq: "SCHEDULED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    schedulerDay
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;

export const getAdminRejectedCatalogues = gql`

subscription getAdminPendingCatalogues {
  catalogues(where: {status: {_eq: "REJECTED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    reject_reason
    schedulerDay
    dental_supplier{
      name
    }
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;



export const getAdminExpCatalogues = gql`

subscription getAdminExpCatalogues {
  catalogues(where: {status: {_eq: "EXPIRED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    schedulerDay   
    dental_supplier{
      name
    }
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;

export const getAdminScduledCatalogues = gql`

subscription getAdminScduledCatalogues {
  catalogues(where: {status: {_eq: "SCHEDULED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    schedulerDay
    dental_supplier{
      name
    }
    views
    status
    catalogue_category{
      id
      name
    }
   
  }
}

`;


export const getAdminApporevedCatalogues = gql`

subscription getAdminPendingCatalogues {
  catalogues(where: {status: {_eq: "APPROVED"}}){

    id
    title
    thumbnail_image
    dental_supplier_id
    catalogue_status
    views
    schedulerDay
    status
    dental_supplier{
      name
    }
    catalogue_category{
      id
      name
    }
   
  }
}

`;


export const addCatalogueTages = gql`

mutation demo($single: catalogue_tags_insert_input!) {
  insert_catalogue_tags_one(object: $single) {
    id
    name
  }
}

`;


export const add_j_CatalogueTages = gql`

mutation demoTwo($single: j_catalogues_catalogue_tags_insert_input!) {
  insert_j_catalogues_catalogue_tags_one(object: $single) {
    id
  }
}

`;


export const removeCatelog = gql`
mutation removeCatelog($id: uuid!) {
  delete_catalogues(where: {id: {_eq: $id}}){
    affected_rows
  }
}
`
  ;

export const updateCatelogStatus = gql`

mutation updateCatelogStatus($id: uuid!, $updateObj: catalogues_set_input!) {
  update_catalogues_by_pk(pk_columns: {id: $id},_set: $updateObj) {
    id
   
  }
}
`;


export const getByPk = gql`
  query getByPk($id: uuid!) {
    catalogues_by_pk(id:$id){
      id
      title
      attachment
      thumbnail_image
      catalogue_status
      schedulerDay
      months_count
      expiryDay
      status
      community_user_type
      catalogue_category{
        id
        name
      }
        catalogue_sub_category{
        id
        name
      }
      j_catalogues_catalogue_tags{
        id
        catalogue_id
        catalogue_tag_id
      }
    
    
    }
  }
  `;


export const getTagsData = gql`

query getTagsData($tagIdArray: [uuid!]){
  catalogue_tags(where:{id:{_in: $tagIdArray}}){
      id
      name
    }
  }

`;


export const updateCatelog = gql`

mutation updateCatelog($id: uuid!, $updateObj: catalogues_set_input!) {
  update_catalogues_by_pk(pk_columns: {id: $id},_set: $updateObj) {
    id
   
  }
}
`;




export const getsubPlan = gql`

query getsubPlan($id: uuid!){
  client_subscriptions(where:{client_id:{_eq:$id}}) {
    id
    subscription_plan_id
    tenure_in_days
    availability
    remaining_availability
    starts_at
    category_availability
    category_availability_update
  }
}

`;

export const updateSubAvilCount = gql`

mutation updateSubAvilCount($cid: uuid!,$sid: uuid!, $subPlanAvailUpdate: client_subscriptions_set_input!) {
  update_client_subscriptions(where:{client_id:{_eq: $cid},subscription_plan_id:{_eq: $sid}},_set: $subPlanAvailUpdate) {
   affected_rows
    
  }
}

`;


export const catSubPlans = gql`
query catSubPlans{
  subscription_plans(where: {category_plan: {_eq: "catalogues"}}){
    id
    updated_at
    name
    price_in_aud
    price_in_usd
    tenure_in_days
    tenure_type
    terms_and_conditions
    type
    description
    benefits
    availability
  
  }
}

`;


export const addNextSubPlan = gql`

mutation addUserSubscriptionRami($userSubscription: UserSubscriptionInput!){
  addUserSubscription(details:$userSubscription){
    id
    payment_intent
  }
}

`;

export const freePlan = gql`

mutation freePlan($userSubscription: user_subscriptions_insert_input!) {
  insert_user_subscriptions_one(object: $userSubscription) {
    id
  }
}

`;


export const supplierProfileData = gql`
query supplierProfileData($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    email
    name
    phone
    present_subscription_id
    community_id
    community_status

  }
}
`;


export const getCatCategoriesCount = gql`

query getCatCategoriesCount($id: uuid!){
  subscription_plans_catalogues_categories(where:{subsciption_plan_id:{_eq:$id}}) {
    id
    count
    catalogue_category_id
    catalogue_category{
      name
    }
    
  }
}

`;


export const getFavCats = gql`
query getFavCats($tagIdArray: [uuid!]){
    catalogues(where:{id:{_in: $tagIdArray}}){
      id
      title
      thumbnail_image

      catalogue_category{
        id
        name
      }
      
    }
  }
`;

export const catMultipleMutation = gql`mutation delete_catalogues_by_pk($idArray: [uuid!]){
  delete_catalogues(where:{id:{_in : $idArray}}){
    affected_rows
  }
}`;


export const getCatalogueTypeOptions = gql`

query getCatalogueTypeOptions {
  catalogue_categories{
    id
    name
  }
}

`;
export const getCatalogueCategoryOptions = gql`

query getCatalogueCategoryOptions {
  catalogue_sub_categories{
    id
    name
  }
}

`;
